
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexbeNRZTVModVcHqSUDkP26afmPP1WNQB5_45IwRehyToiMMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/index.vue?macro=true";
import { default as Loginf8Wl4Xg1cHWBZs981Y9h1ooF7hXWjIvEymVFZ7yYtx0Meta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/Login.vue?macro=true";
import { default as buffersFYNWBBIVE8liigyfgBWDc6xDkPOwcUaq24x6rNBlbdwMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/buffers.vue?macro=true";
import { default as devicesPbFmEse_45OsYUt8FTrMk5fN4vQNoOLsT1MJIzNeV_452AwMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/devices.vue?macro=true";
import { default as domainslhoacUdRDqDm_45F_45QIFDdAKpbRFEo7QV148H4CaLTMvEMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/domains.vue?macro=true";
import { default as bug_45reportsqtt8sViMuVYDqL4sOQ_1oTIXzzZ2ZcnyJFz6ZpOPfREMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/support/bug-reports.vue?macro=true";
import { default as feature_45requestsYxFZ6P_45_IrnC2Cifq_wJkXqNXDR2Uq9un6vsfyz1fMoMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/support/feature-requests.vue?macro=true";
import { default as supportQ_yEPz_45ZpP3_45EGVsp6hmn1MlJKnIAOjwB_qsQZnxWIIMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/support.vue?macro=true";
import { default as accountsnK4nag0rMnx8_45Rrny4oT1GteGr6O3eGijzqSCRcTStsMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/accounts.vue?macro=true";
import { default as rolesj4qTP1dBOQYahjHlGMW_X1TPeuMlIC7zqlAtE0oryaUMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/security/roles.vue?macro=true";
import { default as policiesztpTvoquY5AszkTwZuuGDH3rwOxWQ7ZwlpcZw3h1PMIMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/security/policies.vue?macro=true";
import { default as securitySrEVIsmOExnnrxOWTkakF_45ToYFB_45kgQwOa05XJTHK_QMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/security.vue?macro=true";
import { default as dashboardxL1e0CI_tS8TJ_45jeA6F8Ce_45o0JmN53TV0WaLKsRTiB4Meta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/dashboard.vue?macro=true";
import { default as ftp_45usersEzumcRIx9SK0KgNsBkr6WTbG8gcyiOGiWcaWNZ_45yvMcMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/ftp-users.vue?macro=true";
import { default as mail_45userswZKN4SbGJrF_45QyarCjTG9N8AV_45ytrXxgzt_45B1NJsFB4Meta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/mail-users.vue?macro=true";
import { default as access_45groupsGRpGTaO6TGcWAw2mrRwbpUXmbGV5Npc_45N8JREHDUA7gMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/access-groups.vue?macro=true";
import { default as adf_45managementiz3y6aKUIk8YSuBc_VWn8UonDQGnqyn943ZUDs8_456tAMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/adf-management.vue?macro=true";
import { default as export_45monitorK5hKvAtwfxYu0wx30xK5ZxKthaEgckDcWEJe7Wp5eicMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/export-monitor.vue?macro=true";
import { default as forgot_45password6VFC0U5E4_9wj_456VdXMSXk_RukipkZsJ771p_45ux1WpYMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/forgot-password.vue?macro=true";
import { default as export_45templatesTaW2bCeND0OVZx6vXCicZBzBVxiFGpxw3zbh4kw_45DS0Meta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/export-templates.vue?macro=true";
import { default as software_45versionsj8RiQq_45w2dGff2_45y9wflzpdVHM1BhpVJZ7q_45B6ZXc5oMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/software-versions.vue?macro=true";
import { default as subscription_45plansQq_5bup9PqVGEONjD2MHKrGA7NFCeTmjA8TeyWGBSLcMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/subscription-plans.vue?macro=true";
import { default as key_45pair_45managementlGf8ORCKyOlOlq5OAwfQ_45jyt_45h_MkTGFgww3r78zfDwMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/key-pair-management.vue?macro=true";
import { default as device_45control_45panelpOX2lN6LpNvW5sTawkIoMM1uZmZsVp4xVxnL71KSITEMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/device-control-panel.vue?macro=true";
import { default as export_45templates2BQ2QlyX5IR0DgBAwOVgshTIAPg8rVs3pU_45rXxyGR2IMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/help/export-templates.vue?macro=true";
import { default as dealers_45and_45subdealersenIM3d35ieUNqVqJRv_45aAtfb45j883f8ygpw7XScePYMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/dealers-and-subdealers.vue?macro=true";
import { default as device_45settings_45templatesCr9XhAe6mT_45PYU1Vy3T8ULNbb3WitzIsXF015Bk_KHAMeta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/device-settings-templates.vue?macro=true";
import { default as virtual_45devices_45managementHFpDDIRnVuHYymw7bkFIwRgGYf4mBsGGPSpLmVugwp0Meta } from "C:/repositories/optilink-parent/management-tool-frontend/pages/virtual-devices-management.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexbeNRZTVModVcHqSUDkP26afmPP1WNQB5_45IwRehyToiMMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/index.vue")
  },
  {
    name: "Login",
    path: "/Login",
    meta: Loginf8Wl4Xg1cHWBZs981Y9h1ooF7hXWjIvEymVFZ7yYtx0Meta || {},
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/Login.vue")
  },
  {
    name: "buffers",
    path: "/buffers",
    meta: { ...(buffersFYNWBBIVE8liigyfgBWDc6xDkPOwcUaq24x6rNBlbdwMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/buffers.vue")
  },
  {
    name: "devices",
    path: "/devices",
    meta: { ...(devicesPbFmEse_45OsYUt8FTrMk5fN4vQNoOLsT1MJIzNeV_452AwMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/devices.vue")
  },
  {
    name: "domains",
    path: "/domains",
    meta: domainslhoacUdRDqDm_45F_45QIFDdAKpbRFEo7QV148H4CaLTMvEMeta || {},
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/domains.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: { ...(supportQ_yEPz_45ZpP3_45EGVsp6hmn1MlJKnIAOjwB_qsQZnxWIIMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/support.vue"),
    children: [
  {
    name: "support-bug-reports",
    path: "bug-reports",
    meta: { ...(bug_45reportsqtt8sViMuVYDqL4sOQ_1oTIXzzZ2ZcnyJFz6ZpOPfREMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/support/bug-reports.vue")
  },
  {
    name: "support-feature-requests",
    path: "feature-requests",
    meta: { ...(feature_45requestsYxFZ6P_45_IrnC2Cifq_wJkXqNXDR2Uq9un6vsfyz1fMoMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/support/feature-requests.vue")
  }
]
  },
  {
    name: "accounts",
    path: "/accounts",
    meta: { ...(accountsnK4nag0rMnx8_45Rrny4oT1GteGr6O3eGijzqSCRcTStsMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/accounts.vue")
  },
  {
    name: "security",
    path: "/security",
    meta: { ...(securitySrEVIsmOExnnrxOWTkakF_45ToYFB_45kgQwOa05XJTHK_QMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/security.vue"),
    children: [
  {
    name: "security-roles",
    path: "roles",
    meta: { ...(rolesj4qTP1dBOQYahjHlGMW_X1TPeuMlIC7zqlAtE0oryaUMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/security/roles.vue")
  },
  {
    name: "security-policies",
    path: "policies",
    meta: { ...(policiesztpTvoquY5AszkTwZuuGDH3rwOxWQ7ZwlpcZw3h1PMIMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/security/policies.vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardxL1e0CI_tS8TJ_45jeA6F8Ce_45o0JmN53TV0WaLKsRTiB4Meta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/dashboard.vue")
  },
  {
    name: "ftp-users",
    path: "/ftp-users",
    meta: { ...(ftp_45usersEzumcRIx9SK0KgNsBkr6WTbG8gcyiOGiWcaWNZ_45yvMcMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/ftp-users.vue")
  },
  {
    name: "mail-users",
    path: "/mail-users",
    meta: { ...(mail_45userswZKN4SbGJrF_45QyarCjTG9N8AV_45ytrXxgzt_45B1NJsFB4Meta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/mail-users.vue")
  },
  {
    name: "access-groups",
    path: "/access-groups",
    meta: { ...(access_45groupsGRpGTaO6TGcWAw2mrRwbpUXmbGV5Npc_45N8JREHDUA7gMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/access-groups.vue")
  },
  {
    name: "adf-management",
    path: "/adf-management",
    meta: { ...(adf_45managementiz3y6aKUIk8YSuBc_VWn8UonDQGnqyn943ZUDs8_456tAMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/adf-management.vue")
  },
  {
    name: "export-monitor",
    path: "/export-monitor",
    meta: { ...(export_45monitorK5hKvAtwfxYu0wx30xK5ZxKthaEgckDcWEJe7Wp5eicMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/export-monitor.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/forgot-password.vue")
  },
  {
    name: "export-templates",
    path: "/export-templates",
    meta: { ...(export_45templatesTaW2bCeND0OVZx6vXCicZBzBVxiFGpxw3zbh4kw_45DS0Meta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/export-templates.vue")
  },
  {
    name: "software-versions",
    path: "/software-versions",
    meta: { ...(software_45versionsj8RiQq_45w2dGff2_45y9wflzpdVHM1BhpVJZ7q_45B6ZXc5oMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/software-versions.vue")
  },
  {
    name: "subscription-plans",
    path: "/subscription-plans",
    meta: { ...(subscription_45plansQq_5bup9PqVGEONjD2MHKrGA7NFCeTmjA8TeyWGBSLcMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/subscription-plans.vue")
  },
  {
    name: "key-pair-management",
    path: "/key-pair-management",
    meta: { ...(key_45pair_45managementlGf8ORCKyOlOlq5OAwfQ_45jyt_45h_MkTGFgww3r78zfDwMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/key-pair-management.vue")
  },
  {
    name: "device-control-panel",
    path: "/device-control-panel",
    meta: device_45control_45panelpOX2lN6LpNvW5sTawkIoMM1uZmZsVp4xVxnL71KSITEMeta || {},
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/device-control-panel.vue")
  },
  {
    name: "help-export-templates",
    path: "/help/export-templates",
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/help/export-templates.vue")
  },
  {
    name: "dealers-and-subdealers",
    path: "/dealers-and-subdealers",
    meta: { ...(dealers_45and_45subdealersenIM3d35ieUNqVqJRv_45aAtfb45j883f8ygpw7XScePYMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/dealers-and-subdealers.vue")
  },
  {
    name: "device-settings-templates",
    path: "/device-settings-templates",
    meta: device_45settings_45templatesCr9XhAe6mT_45PYU1Vy3T8ULNbb3WitzIsXF015Bk_KHAMeta || {},
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/device-settings-templates.vue")
  },
  {
    name: "virtual-devices-management",
    path: "/virtual-devices-management",
    meta: { ...(virtual_45devices_45managementHFpDDIRnVuHYymw7bkFIwRgGYf4mBsGGPSpLmVugwp0Meta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/management-tool-frontend/pages/virtual-devices-management.vue")
  }
]